"use client";

import React from "react";
import { PrismDockProvider, usePrismDock } from "@/lib/prism/dock/PrismDockContext";
import { PageContextProvider } from "@/lib/prism/page-context/PageContextProvider";
import { PrismDockWidget } from "@/modules/prism/ui/PrismDockWidget";
import { PilotConsentGate } from "@/components/legal/PilotConsentGate";

function AppChromeInner({ children }: { children: React.ReactNode }) {
    const { isDockedOpen, drawerWidth, isSmallScreen } = usePrismDock();

    // On large screens the dock pushes the workspace aside; on small screens it
    // floats as an overlay so the cramped main content isn't squeezed further.
    const shrink = isDockedOpen && !isSmallScreen;

    return (
        <>
            <div
                className="min-h-screen transition-[margin] duration-200 ease-out"
                style={{
                    marginRight: shrink ? drawerWidth : 0,
                }}
            >
                {children}
            </div>
            <PrismDockWidget />
            <PilotConsentGate />
        </>
    );
}

/** Global app shell: workspace shrink when Prism dock is open + dock widget mount. */
export function AppChrome({ children }: { children: React.ReactNode }) {
    return (
        <PrismDockProvider>
            <PageContextProvider>
                <AppChromeInner>{children}</AppChromeInner>
            </PageContextProvider>
        </PrismDockProvider>
    );
}
